// Bundled default survey templates — used as a fallback when the server-side
// templates file (data/survey-templates.json) is missing or unreadable.
// To edit templates in production, modify the JSON file (or use the admin UI),
// not this file. This is the safety-net snapshot.
export interface SurveyTemplate {
  id: string;
  name: string;
  questions: string[];
}

export const DEFAULT_SURVEY_TEMPLATES: SurveyTemplate[] = [
  {
    id: "cabling",
    name: "Cabling",
    questions: [
      "Patch Panel Layout",
      "Data Jack Locations",
      "Data Jack Heights",
      "Number of drops at each data location",
      "Is conduit roughed in for data location?",
      "Does the data location require conduit or fishing of the wall (low voltage ring)?",
      "Face plate or surface mount biscuit for the data location?",
      "Face plate / surface mount color",
      "Jack Color(s)",
      "Ceiling type in each room",
      "Pathway type in each area",
      "Data rack / cabinet height",
      "Data rack / cabinet location",
      "Ground the data rack / cabinet?",
      "Data Rack / Cabinet Layout",
      "Is there power at the data rack location?",
      "Will the modem be installed in the rack? If so, does it have rack ears? Do we need a shelf?",
      "Do we need sleeves into any rooms?",
      "Do we need to coordinate conduit to any locations in the floor?",
      "Ladder Lengths",
      "Scissor Lift (Yes/No)",
      "Cable Color - important if cable is exposed",
      "Cell coverage in building? (ie do we need radios)",
      "Plenum vs Riser",
      "Permits?",
    ],
  },
  {
    id: "video-surveillance",
    name: "Video Surveillance",
    questions: [
      "Camera Height",
      "Camera Type / Installation Guide",
      "Mount Type / Installation Guide",
      "Do we need conduit to device location?",
      "What MDF / IDF does each camera run back to?",
      "Does each MDF / IDF have adequate switching (total power, total ports, etc.)",
      "Picture of each camera location (specific spot on wall to be mounted)",
      "Where does the camera need to be pointed?",
      "Wall type",
      "Do we need to drill through the wall?",
      "Do we have a range of IPs for the cameras?",
    ],
  },
  {
    id: "access-control",
    name: "Access Control",
    questions: [
      "Card Reader Location / Height",
      "Picture of Card Reader Location",
      "Type of cable for card reader (18/4 or CAT6)",
      "Is there a strike or mag lock in place?",
      "If so, are we moving the strike cable to our door controller?",
      "Are we installing a strike or mag lock? Are we subbing it out?",
      "Is it powered dry or wet?",
      "Are we installing a door contact? Are we reusing an existing door contact? Where does the cable run back to?",
      "Is the frame filled with concrete?",
      "Do we need to run conduit into the frame or conduit/raceway down the frame?",
      "Is the wall surrounding the door drywall, concrete, block, etc.",
      "Where are the controller(s) being mounted? What height? How are we routing the cables to the controller on the backboard?",
      "Where are we mounting power supplies if we are running the strikes / mags dry? Height?",
      "Where will the request to exit button be mounted, if needed? What height?",
      "Where will the request to exit sensor be mounted, if needed?",
      "Is the existing door hardware on each door adequate? Do we need to sub anything out?",
      "What kind of cable will be run to each door? Composite + data, data + 18/4, something else?",
      "How will the door controller be powered? Is the necessary power in place?",
    ],
  },
  {
    id: "intrusion",
    name: "Intrusion",
    questions: [
      "Describe the intrusion detection requirements for this site",
    ],
  },
  {
    id: "networking",
    name: "Networking",
    questions: [
      "Is the equipment programmed, stickered, labeled, etc.",
      "Data rack / cabinet layout",
      "Current AP count?",
      "What is the ceiling type for each AP location?",
      "Is the switching quoted adequate for the devices that are in place?",
      "Is there a UPS?",
      "Is there a data cabinet / rack? / dimensions? (Depth for equipment placement is especially important)",
      "Static IP?",
      "Subnet?",
      "Gateway?",
      "Passwords?",
      "Upload and download speeds?",
      "VPN Users?",
    ],
  },
  {
    id: "voice",
    name: "Voice",
    questions: [
      "Locations on floorplan",
      "Wall Mount phones?",
      "Power adapter vs PoE",
      "Any Headsets?",
      "Standard Users or Utility?",
      "Who owns network?",
      "Need phone bills",
      "What phone numbers to port?",
      "How is fax handled?",
      "Any external paging?",
      "Phone type - desk, cordless, conference room",
      "Is the facility over 7000 SF?",
      "Types of mobile devices? iPhones and androids?",
    ],
  },
  {
    id: "cellular",
    name: "Cellular",
    questions: [
      "Do we need an external antenna?",
      "Do the devices that connect need PoE?",
      "Do we need a lightning suppressor? Is there a grounding location?",
      "Is there power where the equipment will be installed?",
    ],
  },
];

